import { publicConfig } from '@/config/publicConfig'

export const firebaseConfig = {
  apiKey: publicConfig.firebase.apiKey,
  authDomain: publicConfig.firebase.authDomain,
  projectId: publicConfig.firebase.projectId,
  storageBucket: publicConfig.firebase.storageBucket,
  messagingSenderId: publicConfig.firebase.messagingSenderId,
  appId: publicConfig.firebase.appId,
  measurementId: publicConfig.firebase.measurementId,
}

export const Environment = {
  environment: publicConfig.app.environment,
  firestoreEmulatorHost: publicConfig.firebase.firestoreEmulatorHost,
  firebaseAuthEmulatorHost: publicConfig.firebase.authEmulatorHost,
}
